import styled from '@emotion/styled';
import { Variables } from '../../base';

export const PrimaryText = styled.div`
    color: ${Variables.Colors.n100};
    font-weight: 500;
`;

export const SecondaryText = styled.div`
    margin-top: 1px;
    color: ${Variables.Colors.n50};
    font-size: 12px;
    line-height: 1.35;
`;

export const MutedText = styled.div`
    color: ${Variables.Colors.n70};
    font-size: 13px;
`;

export const AmountText = styled.span<{ tone?: 'default' | 'strong' | 'muted' | 'emphasis' | 'credit' | 'warning' }>`
    font-variant-numeric: tabular-nums;
    font-weight: ${props => (props.tone === 'strong' || props.tone === 'emphasis' || props.tone === 'credit' ? 600 : 500)};
    color: ${props => {
        switch (props.tone) {
            case 'muted':
                return Variables.Colors.n50;
            case 'emphasis':
            case 'warning':
                return Variables.Colors.sunset500;
            case 'credit':
                return Variables.Colors.g200;
            case 'strong':
            default:
                return Variables.Colors.n100;
        }
    }};
`;

export const DxList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
`;

export const TypeWithIcon = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${Variables.Colors.n100};
`;
